import {Component, input} from '@angular/core';

@Component({
  selector: 'app-add-device-svg',
  imports: [],
  templateUrl: './add-device-svg.component.html'
})
export class AddDeviceSvgComponent {
  
  color = input('#fff');
}
